<template>
<span class="wrapper" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
  <div class="" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}">
    <!-- <div class="spacer" v-if="$store.state.session.user.UserID === message.From" /> -->
    <div :class="{
      speechBubbleTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedLeft:
        $store.state.session.user.UserID !== message.From &&
        message.continueFromSameBuddy,
      speechBubbleTailedRight:
        $store.state.session.user.UserID === message.From &&
        !message.continueFromSameBuddy,
      speechBubbleNonTailedRight:
        $store.state.session.user.UserID === message.From &&
        message.continueFromSameBuddy
    }"
    >
      <ReactionPicker :visible="showReactionPicker" @select="onToggleReaction" @close="closeReactionPicker" />
      <MessageMenuDropDown :message="message" @open-reactions="openReactionPicker" />

      <div class="senderName" :style="{ color: userColor(message.From) }"
           v-if="message.isGroup === true && $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy "
      >
        {{ getUserNameDisplay(message.From) }}
      </div>

      <ForwardedMessageRow v-if="message.isForwarded" />
      <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />

      <video width="300" height="240" controls>
        <source :src="video" type="video/mp4">
      </video>
      <div class="messageTextContainer">
        {{ message.Body }}
      </div>

      <MessageBalloonInfoRow :message="message" />
    </div>
    <MessageReactions :reactions="message.Reactions" :message="message" @toggle-reaction="onToggleReaction" @open-picker="openReactionPicker" />

    <img class="forwardButton" src="/images/forward.png" v-if="$store.state.session.user.UserID !== message.From && message.MessageType !== 0" @click="forwardMsg">

    <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
  </div>
</span>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import MessageReactions from './common/MessageReactions.vue'
import ReactionPicker from './common/ReactionPicker.vue'

import EventBus from '@/eventbus.js'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown,
    MessageReactions,
    ReactionPicker
  },

  mixins: [messageMixin],
  computed: {
    video () {
      if (this.message.mv <= 1) {
        return this.message.MediaURLs[0]
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = this.ewk(this.message.MediaURLs[0], key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + this.message.MediaURLs[0] + '&s=' + encodeURIComponent(encryptedBody)
      }
    }
  },
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      showReactionPicker: false
    }
  },

  methods: {
    onToggleReaction (emoji) {
      this.toggleReaction(this.message, emoji)
      this.showReactionPicker = false
    },
    openReactionPicker () {
      this.showReactionPicker = true
    },
    closeReactionPicker () {
      this.showReactionPicker = false
    },
    openGalleryView () {
      var vm = this
      this.$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible = true
      setTimeout(function () {
        EventBus.$emit('imageGalleryViewOpenedWithMessage', vm.message)
      }, 50)
    },

    forwardMsg () {
      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    }
  }
}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .imageMessage {
    width: 300px;
    cursor: pointer;
  }

</style>
